import "@fontsource-variable/manrope";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "ol/ol.css";
import "./styles.css";

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import App from "./App";
import PublicApp from "./PublicApp";
import { initAuth } from "./auth/keycloak";
import { ScriptProvider } from "./i18n/script";
import { theme } from "./theme";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

initAuth()
  .then((authenticated) => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <MantineProvider theme={theme} defaultColorScheme="auto">
          <Notifications position="top-right" />
          <QueryClientProvider client={queryClient}>
            <ScriptProvider>
              <BrowserRouter>
                {authenticated ? <App /> : <PublicApp />}
              </BrowserRouter>
            </ScriptProvider>
          </QueryClientProvider>
        </MantineProvider>
      </StrictMode>,
    );
  })
  .catch((e) => {
    document.getElementById("root")!.innerHTML =
      `<div style="font-family:sans-serif;padding:40px"><h2>Keycloak nije dostupan</h2><p>${String(e)}</p>
       <p>Provjeri da li radi <code>docker compose ps</code> (servis keycloak).</p></div>`;
  });
